export default __webpack_public_path__ + "static/registers2-d4c1e42e2edfc87ce260760f5948ed9a.png";